import {
  SubsectionFileNode,
  SubsectionNode,
  SubsectionOptionNode,
  SubsectionTopicNode,
  SubsectionVersionNode,
  TreeNodeType,
} from '../../models';
import { FileInfo, OptionInfo, OptionVersionSimple, TopicInfo } from '../../../shared/interfaces';

export const createTopicNode: (topic: TopicInfo, parent: SubsectionNode) => SubsectionTopicNode = (
  topic: TopicInfo,
  parent: SubsectionNode
): SubsectionTopicNode => ({
  id: topic.topicId,
  name: topic.title,
  type: TreeNodeType.Topic,
  data: topic,
  children: [],
  parent,
  isExpandable: true,
  isSelected: false,
  isExpanded: false,
  depth: 1,
});

export const createOptionNode: (option: OptionInfo, parent: SubsectionNode) => SubsectionOptionNode = (
  option: OptionInfo,
  parent: SubsectionNode
): SubsectionOptionNode => ({
  id: option.optionId,
  name: option.title,
  type: TreeNodeType.Option,
  data: option,
  children: [],
  parent,
  isExpandable: true,
  isSelected: false,
  isExpanded: false,
  depth: 2,
});

export const createVersionNode: (version: OptionVersionSimple, parent: SubsectionNode) => SubsectionVersionNode = (
  version: OptionVersionSimple,
  parent: SubsectionNode
): SubsectionVersionNode => ({
  id: `${parent.id}-${version.versionNumber}`,
  name: version.name,
  type: TreeNodeType.Version,
  data: version,
  children: [],
  parent,
  isExpandable: true,
  isSelected: false,
  isExpanded: false,
  depth: 3,
});

export const createFileNode: (file: FileInfo, parent: SubsectionNode) => SubsectionFileNode = (
  file: FileInfo,
  parent: SubsectionNode
): SubsectionFileNode => ({
  id: file.id,
  name: file.displayName,
  type: TreeNodeType.File,
  data: file,
  children: [],
  parent,
  isExpandable: false,
  depth: 4,
  isSelected: false,
  isExpanded: false,
});
